import React from 'react';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
export function ProductSection() {
  return <div className="bg-cream" data-id="element-154">
      <Section data-id="element-155">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-156">
          {/* Text Content */}
          <div data-id="element-157">
            <SectionTitle className="!text-left mb-4" data-id="element-158">
              Método Dormir sin Lágrimas
            </SectionTitle>
            <p className="text-lg text-charcoal-light mb-8" data-id="element-159">
              No es magia. Es entender cómo funciona el sueño de tu bebé.
            </p>

            <div className="space-y-6 mb-10" data-id="element-160">
              <div className="flex items-start gap-4" data-id="element-161">
                <CheckCircle2 className="w-6 h-6 text-sage-dark flex-shrink-0 mt-1" data-id="element-162" />
                <p className="text-lg text-charcoal" data-id="element-163">
                  Vas a saber exactamente qué hacer cada día
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-164">
                <CheckCircle2 className="w-6 h-6 text-sage-dark flex-shrink-0 mt-1" data-id="element-165" />
                <p className="text-lg text-charcoal" data-id="element-166">
                  Rutinas simples que funcionan en la vida real
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-167">
                <CheckCircle2 className="w-6 h-6 text-sage-dark flex-shrink-0 mt-1" data-id="element-168" />
                <p className="text-lg text-charcoal" data-id="element-169">
                  Basado en el desarrollo natural de tu bebé
                </p>
              </div>
            </div>

            <div className="bg-cream-dark p-6 rounded-xl border border-beige-muted mb-6" data-id="element-170">
              <p className="text-charcoal-light italic mb-4" data-id="element-171">
                No es teoría. No son consejos sueltos.
              </p>
              <div className="flex items-center gap-3 text-charcoal font-bold text-lg" data-id="element-172">
                <ArrowRight className="w-5 h-5 text-gold-hover" data-id="element-173" />
                <p data-id="element-174">Es un método claro que podés aplicar desde hoy</p>
              </div>
            </div>

            <p className="text-charcoal font-medium text-lg mb-6" data-id="element-175">
              💡 Funciona incluso si ya probaste otros métodos y nada te resultó
            </p>

            <div className="flex items-center gap-3 bg-sage-light/30 inline-flex px-6 py-3 rounded-full mb-6" data-id="element-176">
              <CheckCircle2 className="w-5 h-5 text-sage-dark" data-id="element-177" />
              <span className="font-bold text-charcoal" data-id="element-178">
                Más descanso, menos estrés
              </span>
            </div>

            {/* Social Proof */}
            <div className="space-y-3 mt-4" data-id="element-179">
              <p className="text-charcoal font-bold text-lg" data-id="element-180">
                ✨ Más de 1.000 mamás ya aplicaron este método
              </p>
              <p className="text-sage-dark font-medium" data-id="element-181">
                📈 Resultados visibles en los primeros días
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="relative" data-id="element-182">
            <div className="absolute inset-0 bg-sage-light/20 rounded-full blur-[80px] -z-10" data-id="element-183"></div>
            <img src="https://cdn.magicpatterns.com/uploads/68D5XeoZ1xhJQ56BYcs62j/ChatGPT_Image_10_mar_2026,_20_13_23.png" alt="Método Dormir sin Lágrimas" className="w-full h-auto object-contain drop-shadow-xl" data-id="element-184" />
          </div>
        </div>
      </Section>
    </div>;
}